import { render } from "./MyCompanyShare.vue?vue&type=template&id=a8588694&scoped=true"
import script from "./MyCompanyShare.vue?vue&type=script&lang=js"
export * from "./MyCompanyShare.vue?vue&type=script&lang=js"

import "./MyCompanyShare.vue?vue&type=style&index=0&id=a8588694&scoped=true&lang=css"

import exportComponent from "/builds/nex/company-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8588694"]])

export default __exports__